export interface ExposureItemOption {
  value: string;
  label: string;
}

export type ExposureItemCategory = 'food' | 'alcohol' | 'drug' | 'device';

export interface ExposureItem {
  id: number;
  name: string;
  key: string;
  category: ExposureItemCategory;
}

/**
 * Food catalog for Exposure (ids 1–132, aligned with device/backend).
 */
const FOOD_LIST: ExposureItem[] = [
  { id: 1, name: 'Arrosto', key: 'arrosto', category: 'food' },
  { id: 2, name: 'Anguria', key: 'anguria', category: 'food' },
  { id: 3, name: 'Arachidi', key: 'arachidi', category: 'food' },
  { id: 4, name: 'Arancia', key: 'arancia', category: 'food' },
  { id: 5, name: 'Baba', key: 'baba', category: 'food' },
  { id: 6, name: 'Banana', key: 'banana', category: 'food' },
  { id: 7, name: 'Barrette', key: 'barrette', category: 'food' },
  { id: 8, name: 'Biscotti', key: 'biscotti', category: 'food' },
  { id: 9, name: 'Bistecca', key: 'bistecca', category: 'food' },
  { id: 10, name: 'Bombolone', key: 'bombolone', category: 'food' },
  { id: 11, name: 'Bresaola', key: 'bresaola', category: 'food' },
  { id: 12, name: 'Bruschetta', key: 'bruschetta', category: 'food' },
  { id: 13, name: 'Burger', key: 'burger', category: 'food' },
  { id: 14, name: 'Calzone', key: 'calzone', category: 'food' },
  { id: 15, name: 'Cannolo', key: 'cannolo', category: 'food' },
  { id: 16, name: 'Cannoncino', key: 'cannoncino', category: 'food' },
  { id: 17, name: 'Caramelle', key: 'caramelle', category: 'food' },
  { id: 18, name: 'Carote', key: 'carote', category: 'food' },
  { id: 19, name: 'Chips', key: 'chips', category: 'food' },
  { id: 20, name: 'Ciliegie', key: 'ciliegie', category: 'food' },
  { id: 21, name: 'Cioccolato', key: 'cioccolato', category: 'food' },
  { id: 22, name: 'Cono', key: 'cono', category: 'food' },
  { id: 23, name: 'Cookies', key: 'cookies', category: 'food' },
  { id: 24, name: 'Corn Flakes', key: 'corn_flakes', category: 'food' },
  { id: 25, name: 'Coscia Di Pollo', key: 'coscia_di_pollo', category: 'food' },
  { id: 26, name: 'Cotoletta', key: 'cotoletta', category: 'food' },
  { id: 27, name: 'Crackers', key: 'crackers', category: 'food' },
  { id: 28, name: 'Crocchette', key: 'crocchette', category: 'food' },
  { id: 29, name: 'Croissant', key: 'croissant', category: 'food' },
  { id: 30, name: 'Crostata', key: 'crostata', category: 'food' },
  { id: 31, name: 'Cupcake', key: 'cupcake', category: 'food' },
  { id: 32, name: 'Donut', key: 'donut', category: 'food' },
  {
    id: 33,
    name: 'Fette Biscottate',
    key: 'fette_biscottate',
    category: 'food',
  },
  { id: 34, name: 'Focaccia', key: 'focaccia', category: 'food' },
  { id: 35, name: 'Formaggio', key: 'formaggio', category: 'food' },
  { id: 36, name: 'Fritto Misto', key: 'fritto_misto', category: 'food' },
  { id: 37, name: 'Frutti Di Bosco', key: 'frutti_di_bosco', category: 'food' },
  { id: 38, name: 'Gamberi', key: 'gamberi', category: 'food' },
  { id: 39, name: 'Gorgonzola', key: 'gorgonzola', category: 'food' },
  { id: 40, name: 'Hamburger', key: 'hamburger', category: 'food' },
  { id: 41, name: 'Hot Dog', key: 'hot_dog', category: 'food' },
  { id: 42, name: 'Insalata', key: 'insalata', category: 'food' },
  { id: 43, name: 'Insalata Orzo', key: 'insalata_orzo', category: 'food' },
  { id: 44, name: 'Kebab', key: 'kebab', category: 'food' },
  { id: 45, name: 'Lasagne', key: 'lasagne', category: 'food' },
  { id: 46, name: 'Macarons', key: 'macarons', category: 'food' },
  { id: 47, name: 'Macedonia', key: 'macedonia', category: 'food' },
  { id: 48, name: 'Meringa', key: 'meringa', category: 'food' },
  { id: 49, name: 'Minestrone', key: 'minestrone', category: 'food' },
  { id: 50, name: 'Muffin', key: 'muffin', category: 'food' },
  { id: 51, name: 'Nighiri', key: 'nighiri', category: 'food' },
  { id: 52, name: 'Panettone', key: 'panettone', category: 'food' },
  { id: 53, name: 'Parmigiana', key: 'parmigiana', category: 'food' },
  {
    id: 54,
    name: 'Pasticcino Frutta',
    key: 'pasticcino_frutta',
    category: 'food',
  },
  { id: 55, name: 'Patatine Fritte', key: 'patatine_fritte', category: 'food' },
  { id: 56, name: 'Pere', key: 'pere', category: 'food' },
  {
    id: 57,
    name: 'Pesce Alla Griglia',
    key: 'pesce_alla_griglia',
    category: 'food',
  },
  { id: 58, name: 'Pesce Spada', key: 'pesce_spada', category: 'food' },
  { id: 59, name: 'Pesche', key: 'pesche', category: 'food' },
  { id: 60, name: 'Pollo Ai Ferri', key: 'pollo_ai_ferri', category: 'food' },
  { id: 61, name: 'Pomodori', key: 'pomodori', category: 'food' },
  { id: 62, name: 'Praline', key: 'praline', category: 'food' },
  { id: 63, name: 'Ricotta', key: 'ricotta', category: 'food' },
  { id: 64, name: 'Riso', key: 'riso', category: 'food' },
  { id: 65, name: 'Sacher', key: 'sacher', category: 'food' },
  { id: 66, name: 'Saint Honore', key: 'saint_honore', category: 'food' },
  { id: 67, name: 'Salame', key: 'salame', category: 'food' },
  { id: 68, name: 'Salatini', key: 'salatini', category: 'food' },
  { id: 69, name: 'Salsiccia', key: 'salsiccia', category: 'food' },
  { id: 70, name: 'Simmenthal', key: 'simmenthal', category: 'food' },
  { id: 71, name: 'Snack', key: 'snack', category: 'food' },
  {
    id: 72,
    name: 'Snack Cioccolato',
    key: 'snack_cioccolato',
    category: 'food',
  },
  { id: 73, name: 'Spiedini', key: 'spiedini', category: 'food' },
  { id: 74, name: 'Stinco', key: 'stinco', category: 'food' },
  { id: 75, name: 'Sushi', key: 'sushi', category: 'food' },
  { id: 76, name: 'Taco', key: 'taco', category: 'food' },
  { id: 77, name: 'Tartare Tonno', key: 'tartare_tonno', category: 'food' },
  {
    id: 78,
    name: 'Torta Margherita',
    key: 'torta_margherita',
    category: 'food',
  },
  { id: 79, name: 'Torta Paradiso', key: 'torta_paradiso', category: 'food' },
  { id: 80, name: 'Tortilla', key: 'tortilla', category: 'food' },
  { id: 81, name: 'Uovo E Bacon', key: 'uovo_e_bacon', category: 'food' },
  { id: 82, name: 'Uva', key: 'uva', category: 'food' },
  {
    id: 83,
    name: 'Verdure Grigliate',
    key: 'verdure_grigliate',
    category: 'food',
  },
  { id: 84, name: 'Yogurt', key: 'yogurt', category: 'food' },
  { id: 85, name: 'Asian Food', key: 'asian_food', category: 'food' },
  { id: 86, name: 'Cake', key: 'cake', category: 'food' },
  { id: 87, name: 'Nuts', key: 'nuts', category: 'food' },
  { id: 88, name: 'Bread', key: 'bread', category: 'food' },
  { id: 89, name: 'Brownies', key: 'brownies', category: 'food' },
  { id: 90, name: 'Cereal', key: 'cereal', category: 'food' },
  { id: 91, name: 'Chocolate', key: 'chocolate', category: 'food' },
  { id: 92, name: 'Cookies', key: 'cookies', category: 'food' },
  { id: 93, name: 'Cream Cake', key: 'cream_cake', category: 'food' },
  { id: 94, name: 'Croissants', key: 'croissants', category: 'food' },
  { id: 95, name: 'Cupcakes', key: 'cupcakes', category: 'food' },
  { id: 96, name: 'Donuts', key: 'donuts', category: 'food' },
  { id: 97, name: 'French Fries', key: 'french_fries', category: 'food' },
  { id: 98, name: 'Bacon', key: 'bacon', category: 'food' },
  { id: 99, name: 'Fried Chicken', key: 'fried_chicken', category: 'food' },
  { id: 100, name: 'Fruit', key: 'fruit', category: 'food' },
  { id: 101, name: 'Ice Cream', key: 'ice_cream', category: 'food' },
  { id: 102, name: 'Spaghetti', key: 'spaghetti', category: 'food' },
  { id: 103, name: 'Mexican Food', key: 'mexican_food', category: 'food' },
  { id: 104, name: 'Pancakes', key: 'pancakes', category: 'food' },
  { id: 105, name: 'Peanut Butter', key: 'peanut_butter', category: 'food' },
  { id: 106, name: 'Pizza', key: 'pizza', category: 'food' },
  { id: 107, name: 'Popcorn', key: 'popcorn', category: 'food' },
  { id: 108, name: 'Chips', key: 'chips', category: 'food' },
  { id: 109, name: 'Pretzels', key: 'pretzels', category: 'food' },
  { id: 110, name: 'Noodles', key: 'noodles', category: 'food' },
  { id: 111, name: 'Steak', key: 'steak', category: 'food' },
  { id: 112, name: 'Yogurt', key: 'yogurt', category: 'food' },
  { id: 113, name: 'Baked Potato', key: 'baked_potato', category: 'food' },
  { id: 114, name: 'Brigadeiro', key: 'brigadeiro', category: 'food' },
  { id: 115, name: 'Joelho', key: 'joelho', category: 'food' },
  { id: 116, name: 'Feijoada', key: 'feijoada', category: 'food' },
  { id: 117, name: 'Orange Juice', key: 'orange_juice', category: 'food' },
  { id: 118, name: 'Soft Drink', key: 'soft_drink', category: 'food' },
  {
    id: 119,
    name: 'Spaghetti Bolognese',
    key: 'spaghetti_bolognese',
    category: 'food',
  },
  { id: 120, name: 'Acai Bowl', key: 'acai_bowl', category: 'food' },
  { id: 121, name: 'Pacoca', key: 'pacoca', category: 'food' },
  { id: 122, name: 'Pao De Queijo', key: 'pao_de_queijo', category: 'food' },
  { id: 123, name: 'Oreo', key: 'oreo', category: 'food' },
  {
    id: 124,
    name: 'Beef Stroganoff',
    key: 'beef_stroganoff',
    category: 'food',
  },
  { id: 125, name: 'Empada', key: 'empada', category: 'food' },
  {
    id: 126,
    name: 'Coxinha De Galinha',
    key: 'coxinha_de_galinha',
    category: 'food',
  },
  { id: 127, name: 'Pastries', key: 'pastries', category: 'food' },
  { id: 128, name: 'Snacks', key: 'snacks', category: 'food' },
  { id: 129, name: 'Wafer', key: 'wafer', category: 'food' },
  { id: 130, name: 'Budin', key: 'budin', category: 'food' },
  { id: 131, name: 'Pastel', key: 'pastel', category: 'food' },
  { id: 132, name: 'Affogato', key: 'affogato', category: 'food' },
];

/**
 * Alcohol catalog for Exposure (ids 133–152, aligned with Unreal Data Table).
 */
const ALCOHOL_LIST: ExposureItem[] = [
  { id: 133, name: 'Zombie', key: 'zombie', category: 'alcohol' },
  { id: 134, name: 'Gin Tonic', key: 'gin_tonic', category: 'alcohol' },
  { id: 135, name: 'Moscow Mule', key: 'moscow_mule', category: 'alcohol' },
  { id: 136, name: 'Negroni', key: 'negroni', category: 'alcohol' },
  {
    id: 137,
    name: 'Long Island Ice Tea',
    key: 'long_island_ice_tea',
    category: 'alcohol',
  },
  { id: 138, name: 'Mai Tai', key: 'mai_tai', category: 'alcohol' },
  { id: 139, name: 'Margarita', key: 'margarita', category: 'alcohol' },
  { id: 140, name: 'Mimosa', key: 'mimosa', category: 'alcohol' },
  {
    id: 141,
    name: "Dark 'n' Stormy",
    key: 'dark_n_stormy',
    category: 'alcohol',
  },
  { id: 142, name: 'Mojito', key: 'mojito', category: 'alcohol' },
  { id: 143, name: 'Prosecco', key: 'prosecco', category: 'alcohol' },
  { id: 144, name: 'Vodka', key: 'vodka', category: 'alcohol' },
  { id: 145, name: 'Grappa', key: 'grappa', category: 'alcohol' },
  { id: 146, name: 'Rum', key: 'rum', category: 'alcohol' },
  { id: 147, name: 'Gin', key: 'gin', category: 'alcohol' },
  { id: 148, name: 'Whisky', key: 'whisky', category: 'alcohol' },
  {
    id: 149,
    name: 'Birra (lattina)',
    key: 'birra_lattina',
    category: 'alcohol',
  },
  { id: 150, name: 'Birra (vetro)', key: 'birra_vetro', category: 'alcohol' },
  { id: 151, name: 'Vino rosso', key: 'vino_rosso', category: 'alcohol' },
  { id: 152, name: 'Vino bianco', key: 'vino_bianco', category: 'alcohol' },
];

/**
 * Drug catalog for Exposure (ids 153–160, aligned with Unreal Data Table).
 */
const DRUG_LIST: ExposureItem[] = [
  { id: 153, name: 'Sigaretta', key: 'sigaretta', category: 'drug' },
  {
    id: 154,
    name: 'Sigaretta elettronica',
    key: 'sigaretta_elettronica',
    category: 'drug',
  },
  { id: 155, name: 'Hashish', key: 'hashish', category: 'drug' },
  { id: 156, name: 'Cocaina', key: 'cocaina', category: 'drug' },
  { id: 157, name: 'Crack', key: 'crack', category: 'drug' },
  { id: 158, name: 'Eroina', key: 'eroina', category: 'drug' },
  { id: 159, name: 'MDMA', key: 'mdma', category: 'drug' },
  { id: 160, name: 'Ketamina', key: 'ketamina', category: 'drug' },
];

/**
 * Device catalog for Exposure (ids 161–164, aligned with Unreal Data Table).
 * Unreal rows: Smartphone, Tablet, ConsoleGame, SlotMachine.
 */
const DEVICE_LIST: ExposureItem[] = [
  { id: 161, name: 'Smartphone', key: 'smartphone', category: 'device' },
  { id: 162, name: 'Tablet', key: 'tablet', category: 'device' },
  {
    id: 163,
    name: 'Console / videogioco',
    key: 'console_game',
    category: 'device',
  },
  { id: 164, name: 'Slot machine', key: 'slot_machine', category: 'device' },
];

/**
 * Unified Exposure catalog (food + alcohol + drug + device), ordered by ID.
 * Configuration and payloads use item IDs; display uses names via getFoodNameById / getFoodNamesByIds.
 */
const EXPOSURE_ITEMS: ExposureItem[] = [
  ...FOOD_LIST,
  ...ALCOHOL_LIST,
  ...DRUG_LIST,
  ...DEVICE_LIST,
];

const ITEM_BY_ID = new Map<string, string>(
  EXPOSURE_ITEMS.map(item => [String(item.id), item.name])
);

export const CATEGORY_LABELS: Record<ExposureItemCategory, string> = {
  food: 'Cibo',
  alcohol: 'Alcol',
  drug: 'Droghe',
  device: 'Dispositivi',
};

export const CATEGORY_ORDER: ExposureItemCategory[] = [
  'food',
  'alcohol',
  'drug',
  'device',
];

/** Checkbox / filter options: Cibo → Alcol → Droghe → Dispositivi. */
export const exposureCategoryOptions: {
  value: ExposureItemCategory;
  label: string;
}[] = CATEGORY_ORDER.map(value => ({
  value,
  label: CATEGORY_LABELS[value],
}));

/** Flat options (legacy / debug). */
export const foodOptions: ExposureItemOption[] = EXPOSURE_ITEMS.map(item => ({
  value: String(item.id),
  label: item.name,
}));

/** Grouped options for Select/MultiSelect: Cibo → Alcol → Droghe → Dispositivi, items sorted by name. */
export const exposureItemOptionsGrouped: {
  group: string;
  items: ExposureItemOption[];
}[] = CATEGORY_ORDER.flatMap(category => {
  const items = EXPOSURE_ITEMS.filter(item => item.category === category)
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name, 'it'))
    .map(item => ({ value: String(item.id), label: item.name }));
  if (items.length === 0) return [];
  return [{ group: CATEGORY_LABELS[category], items }];
});

/** All catalog item IDs for the selected categories (category order, then catalog id). */
export function getExposureItemIdsByCategories(
  categories: readonly ExposureItemCategory[]
): number[] {
  const selected = new Set(categories);
  return CATEGORY_ORDER.filter(category => selected.has(category)).flatMap(
    category =>
      EXPOSURE_ITEMS.filter(item => item.category === category).map(
        item => item.id
      )
  );
}

/** Returns the item name for an ID, or the id if not found. */
export function getFoodNameById(id: string | number): string {
  const key = typeof id === 'number' ? String(id) : id;
  return ITEM_BY_ID.get(key) ?? String(id);
}

/** Returns comma-separated names for display (e.g. toasts, tables). */
export function getFoodNamesByIds(ids: (string | number)[]): string {
  if (!Array.isArray(ids) || ids.length === 0) return '';
  return ids.map(getFoodNameById).join(', ');
}
